import { render } from "./TransactionsTable.vue?vue&type=template&id=205ba830&scoped=true"
import script from "./TransactionsTable.vue?vue&type=script&lang=js"
export * from "./TransactionsTable.vue?vue&type=script&lang=js"

import "./TransactionsTable.vue?vue&type=style&index=0&id=205ba830&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205ba830"]])

export default __exports__